/**
 * Hook to check if the current user has a permission.
 * Use only for UI visibility - backend enforces permissions.
 */
import { useAuth } from '../contexts/AuthContext';

export function usePermission(key: string): boolean {
  const { user } = useAuth();
  if (!user) return false;
  if (user.role === 'admin') return true;
  const permissions = user.permissions;
  if (permissions?.[key] === true) return true;
  // Backward compatibility: legacy user-level flags
  if (key === 'add_edit_business' && user.can_edit_businesses === true) return true;
  if (key === 'manage_replacements' && user.can_manage_replacements === true) return true;
  return false;
}
